import { admin2 } from '@/api/instance'
import { isBenefitSharingEnabled } from '@/use/useOrgBenefitControl'

export const CheckCouponLinePush = async ({
  shopId,
}) => {
  return await admin2({
    method: 'GET',
    url: `${shopId}/coupon/checkLinePushConfig`,
  })
}
// => 創建使用券
export const CreateCoupon = async ({
  shopId,
  image,
  name,
  expType,
  expAt,
  expDay,
  endOfPeriodUnit,
  showMinute,
  notice,
}) => {
  const res = await admin2({
    method: 'post',
    url: `/${shopId}/coupon`,
    data: {
      image,
      name,
      expType,
      expAt,
      expDay,
      endOfPeriodUnit,
      showMinute,
      notice,
    },
  })
  return res
}

/**
 * 取得使用券列表
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {number} [params.start=0] - 查詢起始
 * @param {number} [params.limit=100] - 查詢筆數
 * @param {string} [params.name] - 名稱搜尋
 * @param {string} [params.type] - 票券類型
 * @param {boolean} [params.crossShop] - 是否查詢跨店共用資料
 * @param {string} [params.benefitShopScope] - 適用類型篩選（local/all/shared），優先於 crossShop
 * @param {string} [params.issuingShopId] - 發行店篩選
 * @returns {Promise<Array>} 使用券列表
 */
export const GetCoupon = async ({ shopId, start, limit, name, type, crossShop, benefitShopScope, issuingShopId }) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/coupon`,
    params: {
      start,
      limit,
      name,
      type,
      benefitShopScope: benefitShopScope || (crossShop == null ? (isBenefitSharingEnabled('coupon', shopId) ? 'all' : undefined) : (crossShop ? 'all' : 'local')),
      issuingShopId,
    },
  })
  return res
}

/**
 * 取得使用券總數
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {number} [params.start=0] - 查詢起始
 * @param {number} [params.limit=100] - 查詢筆數
 * @param {string} [params.type] - 票券類型
 * @param {boolean} [params.crossShop] - 是否查詢跨店共用資料
 * @param {string} [params.benefitShopScope] - 適用類型篩選（local/all/shared），優先於 crossShop
 * @param {string} [params.issuingShopId] - 發行店篩選
 * @returns {Promise<Object>} 使用券總數
 */
export const GetCouponCount = async ({ shopId, start, limit, type, crossShop, benefitShopScope, issuingShopId }) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/coupon/count`,
    params: {
      start,
      limit,
      type,
      benefitShopScope: benefitShopScope || (crossShop == null ? (isBenefitSharingEnabled('coupon', shopId) ? 'all' : undefined) : (crossShop ? 'all' : 'local')),
      issuingShopId,
    },
  })
  return res
}

// => 查找使用券
export const FindCoupon = async ({ shopId, id }) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/coupon/${id}`,
  })
  return res
}

// => 更新使用券
export const UpdateCoupon = async ({
  shopId,
  id,
  image,
  name,
  expType,
  expAt,
  expDay,
  endOfPeriodUnit,
  showMinute,
  notice,
}) => {
  const res = await admin2({
    method: 'put',
    url: `/${shopId}/coupon/${id}`,
    data: {
      image,
      name,
      expType,
      expAt,
      expDay,
      endOfPeriodUnit,
      showMinute,
      notice,
    },
  })
  return res
}

// => 刪除使用券
export const DeleteCoupon = async ({ shopId, id }) => {
  const res = await admin2({
    method: 'delete',
    url: `/${shopId}/coupon/${id}`,
  })
  return res
}
